import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { NEWASSESSMENTPOPUP_URL } from "../service/data";

const initialState = {
  newAssessmentData: {},
  newAssessmentLoading: false,
  newAssessmentError: null,
  newAssessmentSuccess: false,
  newAssessmentStatus: null,
};

export const newAssessmentCall = createAsyncThunk(
  "newAssessmentSlice/newAssessmentCall",
  async ({ assessmentFormData, accessToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          // Authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      };
      const { data } = await axios.post(
        NEWASSESSMENTPOPUP_URL,
        assessmentFormData,
        config
      );

      return data;
    } catch (error) {
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const newAssessmentSlice = createSlice({
  name: "newAssessment",
  initialState,
  reducers: {
    setNewAssessmentData: (state, { payload }) => {
      state.newAssessmentData = payload;
    },
  },
  extraReducers: {
    [newAssessmentCall.pending]: (state) => {
      state.newAssessmentLoading = true;
      state.newAssessmentError = null;
    },
    [newAssessmentCall.fulfilled]: (state, { payload }) => {
      state.newAssessmentLoading = false;
      state.newAssessmentSuccess = true;
      state.newAssessmentData = payload;
    },
    [newAssessmentCall.rejected]: (state, { payload }) => {
      state.newAssessmentLoading = false;
      state.newAssessmentError = payload;
    },
  },
});

export const { setNewAssessmentData } = newAssessmentSlice.actions;

export default newAssessmentSlice.reducer;
